<div class="popup-container">
  <!-- Header Section -->
  <div class="popup-header text-center mb-4">
    <div class="popup-icon mb-3">
      <i class="fa fa-graduation-cap fa-3x text-primary"></i>
    </div>
    <h3 class="popup-title fw-bold text-primary mb-2">{{ 'POPUP.TAKE_CLASSES_IN_ORDER' | translate }}</h3>
    <!-- <p class="text-muted mb-0">Subtitle</p> -->
  </div>

  <!-- Instructions Section -->
  <div class="popup-content mb-4">
    <div class="instruction-list">
      <div class="instruction-item d-flex align-items-start mb-3">
        <div class="step-number me-3">
          <span class="badge bg-primary rounded-circle">1</span>
        </div>
        <div class="step-content">
          <div class="step-icon me-2">
            <i class="fa fa-play-circle text-primary"></i>
          </div>
          <p class="mb-0">{{ 'POPUP.FIRST_WATCH_VIDEO' | translate }}</p>
        </div>
      </div>

      <div class="instruction-item d-flex align-items-start mb-3">
        <div class="step-number me-3">
          <span class="badge bg-info rounded-circle">2</span>
        </div>
        <div class="step-content">
          <div class="step-icon me-2">
            <i class="fa fa-book text-info"></i>
          </div>
          <p class="mb-0">{{ 'POPUP.SECOND_STUDY_EBOOK' | translate }}</p>
        </div>
      </div>

      <div class="instruction-item d-flex align-items-start mb-3">
        <div class="step-number me-3">
          <span class="badge bg-success rounded-circle">3</span>
        </div>
        <div class="step-content">
          <div class="step-icon me-2">
            <i class="fa fa-question-circle text-success"></i>
          </div>
          <p class="mb-0">{{ 'POPUP.THIRD_TAKE_QUIZ' | translate }}</p>
        </div>
      </div>

      <div class="instruction-item d-flex align-items-start mb-3">
        <div class="step-number me-3">
          <span class="badge bg-warning rounded-circle">4</span>
        </div>
        <div class="step-content">
          <div class="step-icon me-2">
            <i class="fa fa-clock-o text-warning"></i>
          </div>
          <p class="mb-0">{{ 'POPUP.FOURTH_WAIT_WEEK' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Messages Section -->
  <div class="popup-errors" *ngIf="error_message || error_message1">
    <div class="alert alert-warning bg-light-warning border-0 mb-3" *ngIf="error_message" role="alert">
      <div class="d-flex align-items-center">
        <i class="fa fa-exclamation-triangle me-3 text-warning"></i>
        <span>{{ error_message }}</span>
      </div>
    </div>
    <div class="alert alert-danger bg-light-danger border-0 mb-3" *ngIf="error_message1" role="alert">
      <div class="d-flex align-items-center">
        <i class="fa fa-times-circle me-3 text-danger"></i>
        <span>{{ error_message1 }}</span>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="popup-actions text-center">
    <div class="d-grid gap-2">
      <button 
        type="button" 
        class="btn btn-outline-secondary"
        [mat-dialog-close]="true"
      >
        <i class="fa fa-times me-2"></i>{{ 'POPUP.CLOSE_BUTTON' | translate }}
      </button>
    </div>
  </div>
</div>
